import { Button } from '@ifood/pomodoro-components';
import styled from 'styled-components';

export const SearchButtonStyles = styled(Button)`
  width: 48px;
  height: 48px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
`;
